export default __webpack_public_path__ + "static/media/5.d5e83e01.jpg";